import * as amplitude from '@amplitude/analytics-browser';
import { clientEnv } from './env';

let initialized = false;

export function initAnalytics() {
  if (initialized || !clientEnv.amplitudeApiKey) return;
  amplitude.init(clientEnv.amplitudeApiKey, {
    defaultTracking: {
      sessions: true,
      pageViews: false,
      formInteractions: false,
      fileDownloads: false,
    },
  });
  initialized = true;
}

export function track(name: string, properties?: Record<string, unknown>) {
  if (!initialized) return;
  amplitude.track(name, {
    path: window.location.pathname,
    platform: 'web',
    ...properties,
  });
}

export function identifyUser(
  userId: string | null,
  properties?: Record<string, string | number | boolean>,
) {
  if (!initialized) return;
  if (!userId) {
    amplitude.reset();
    return;
  }
  amplitude.setUserId(userId);
  if (properties) {
    const identify = new amplitude.Identify();
    Object.entries(properties).forEach(([key, value]) => identify.set(key, value));
    amplitude.identify(identify);
  }
}
